import React from 'react';
import PropTypes from 'prop-types';

import { formatMoney } from '../../../shared/format';
import { getCurrencyIcon } from '../../../../../../shared/js/get-currency-icon';

const propTypes = {
	intl: PropTypes.func,
	value: PropTypes.object,
	currency: PropTypes.string
};

const Payouts = ({ intl, value, currency }) => (
	<div className={`payouts__item ${process.env.CPA_ENV === 'rocket' ? 'payouts__item-wide' : ''}`}>
		{ value[currency]['debt'] && (
			<p className="payouts__value payouts__value--debt">
				<span className="payouts__value-sign">{getCurrencyIcon(value[currency]['debt'].currency)}</span>
				<span className="payouts__value-amount">{formatMoney(value[currency]['debt'].amount, true)}</span>
			</p>
		) }

		<p className="payouts__value payouts__value--payout">
			<span className="payouts__value-sign">{intl('Payouts')}</span>
			<span className="payouts__value-amount">
				{ value[currency]['payouts'] ? formatMoney(value[currency]['payouts'].amount, true) : 0  }
			</span>
		</p>

		<p className="payouts__value payouts__value--balance">
			<span className="payouts__value-sign">{intl('Accounts')}</span>
			<span className="payouts__value-amount">
				{ value[currency]['onBalance'] ?  formatMoney(value[currency]['onBalance'].amount, true) : 0 }
			</span>
		</p>
	</div>
);

Payouts.propTypes = propTypes;
export default Payouts;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/debt-widget/payouts-item.js